var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "90%",
      "scrollable": true,
      "name": "client-visit-now-add",
      "classes": "modal_default",
      "clickToClose": true
    },
    on: {
      "opened": _vm.onOpen,
      "closed": _vm.onHidden
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "visit-now-dialog"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Naplánovat návštěvu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisit(_vm.visit)
      }
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.planned_for),
      expression: "visit.planned_for"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "autofocus": "autofocus",
      "data-testid": "visit-now-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.planned_for = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.purpose_id),
      expression: "visit.purpose_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation",
      "data-testid": "visit-now-purpose"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.purpose_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.visitPurposeChanged($event)
      }]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      attrs: {
        "data-duration": visit_purpose.duration
      },
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.visit_template_id),
      expression: "visit.visit_template_id"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "visitTemplateSelect",
      "disabled": _vm.visitTemplates === false,
      "data-testid": "visit-now-template"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.visit_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.visitTemplates), function(visit_template, index) {
    return _c('option', {
      domProps: {
        "value": visit_template.id,
        "selected": index === 0
      }
    }, [_vm._v(_vm._s(visit_template.name))])
  }), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("bez šablony")])], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration",
      "data-testid": "visit-now-duration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
    return (duration % 2 === 0) ? _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")]) : _vm._e()
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("\n                    akutní "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.acute),
      expression: "visit.acute"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "data-testid": "visit-now-acute"
    },
    domProps: {
      "checked": Array.isArray(_vm.visit.acute) ? _vm._i(_vm.visit.acute, null) > -1 : (_vm.visit.acute)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.visit.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visit.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.visit.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visit.acute = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-inline mt-2"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.note),
      expression: "visit.note"
    }],
    staticClass: "form-control col-sm-9 ml-sm-1 mr-sm-2",
    attrs: {
      "type": "text",
      "aria-describedby": "noteHelp",
      "id": "note",
      "data-testid": "visit-now-note"
    },
    domProps: {
      "value": (_vm.visit.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.visit.note = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.visitPending) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "data-testid": "visit-now-submit"
    }
  }, [_vm._v("Přidat")]) : _c('button', {
    staticClass: "btn btn-success disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9937938c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/modals/AddVisitNow.vue
// module id = 624
// module chunks = 0